import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

import searchIcon from "../assets/images/search_icon.svg";
import addIcon from "../assets/images/add-icon.svg";
import arrowIcon from "../assets/images/Arrow.svg";
import editIcon from "../assets/images/edit_icon.svg";

import "../styles/dataTable.css";
import "../styles/manageCategory.css";

const ManageFaq = () => {
  const navigate = useNavigate();

  const [faqUrls, setFaqUrls] = useState([]);
  const [search, setSearch] = useState("");

  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");


  // --------------------------------------------------
  // FETCH FAQ URLS
  // --------------------------------------------------

  const fetchFaqUrls = async () => {
    try {
      const { data } = await api.get("/api/Faqurl/getall");

      if (data.status === "success") {
        setFaqUrls(data.data || []);
      }

    } catch (err) {
      console.error(
        "Failed to load FAQ URLs",
        err
      );
    }
  };


  useEffect(() => {
    fetchFaqUrls();
  }, []);


  // --------------------------------------------------
  // SEARCH
  // --------------------------------------------------

  const filteredData = faqUrls.filter((item) =>
    (item.page_url || "")
      .toLowerCase()
      .includes(search.toLowerCase())
  );


  // --------------------------------------------------
  // SORT
  // --------------------------------------------------

  if (sortField) {

    filteredData.sort((a, b) => {

      const valA = a[sortField] ?? "";
      const valB = b[sortField] ?? "";

      return sortOrder === "asc"
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));

    });

  }


  // --------------------------------------------------
  // PAGINATION
  // --------------------------------------------------

  const totalPages = Math.max(
    1,
    Math.ceil(
      filteredData.length / entriesPerPage
    )
  );


  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );


  useEffect(() => {

    if (currentPage > totalPages) {
      setCurrentPage(1);
    }

  }, [
    search,
    entriesPerPage,
    totalPages,
    currentPage
  ]);


  // --------------------------------------------------
  // SORT HANDLER
  // --------------------------------------------------

  const handleSort = (field) => {

    if (sortField === field) {

      setSortOrder((prev) =>
        prev === "asc"
          ? "desc"
          : "asc"
      );

    } else {

      setSortField(field);
      setSortOrder("asc");

    }

  };


  // --------------------------------------------------
  // ADD FAQ
  // --------------------------------------------------

  const handleAdd = () => {

    navigate("/faqs/add");

  };


  // --------------------------------------------------
  // EDIT FAQ
  // --------------------------------------------------

  const handleEdit = (row) => {

    navigate(
      `/faqs/edit/${encodeURIComponent(row.page_url)}`
    );

  };


  const handleDelete = async (id) => {
    // if (!window.confirm("Are you sure you want to delete this MetaTag?")) return;

    // try {
    //     const res = await api.get(`/metatag/delete/${id}`);

    //     if (res.data.status === "success") {
    //     toast.success("MetaTag deleted successfully");
    //     setMetaTags(metaTags.filter((item) => item.id !== id));
    //     } else {
    //     toast.error("Failed to delete MetaTag");
    //     }
    // } catch (error) {
    //     console.error("Error deleting meta tag:", error);
    //     toast.error("Error deleting meta tag");
    // }
  };


  return (
    <div style={{ position: "relative" , height: 'auto', overflow: 'hidden'}}>
      {/* Blur background when popup open */}
      <div
        style={{
          padding: "20px",
        }}
      >
        <div className="table-header">
          <h2 style={{ fontWeight: 700 }}>Manage FAQ's</h2>

          <div className="search-container">
            <input
              type="text"
              value={search}
              placeholder="search"
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
            <img src={searchIcon} className="search-icon" alt="search-icon" />
          </div>

          <div className="entries-container">
            <label>Show: </label>
            <select
              value={entriesPerPage}
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
            >
              <option value={10}>10 Entries</option>
              <option value={50}>50 Entries</option>
              <option value={100}>100 Entries</option>
            </select>
          </div>

          <div className="action-btn">
            <button
              onClick={handleAdd}
            >
              <img src={addIcon} alt="add-icon" /> Add FAQ
            </button>
          </div>
        </div>

        {/* Table */}
        <table width="100%" cellPadding="26" className="table-no-outer-border">
          <thead>
            <tr>
              <th>Sr.</th>
              <th onClick={() => handleSort("page_url")}>URL</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length ? (
              paginatedData.map((row, i) => (
                <tr key={row.page_url}>
                  <td>{(currentPage - 1) * entriesPerPage + i + 1}</td>
                  <td>{row.page_url}</td>

                  <td>

                    <div className="buttons-actions">
                        <button className="edit-button" onClick={() => handleEdit(row)}>
                        <img src={editIcon} alt="edit" /> Edit
                        </button>

                        {/* <button
                            className="delete-button"
                            onClick={() => handleDelete(row.page_url)}
                        
                        >
                            <img src={deleteIcon} alt="delete" />
                        </button> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>
                  No data
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div style={{ padding: "30px", textAlign: "center" }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          >
            <img src={arrowIcon} alt="arrow-icon" />
          </button>

          {Array.from({ length: totalPages }, (_, k) => (
            <button
              key={k + 1}
              style={{
                background: currentPage === k + 1 ? "#D9D9D9" : "#fff",
              }}
              onClick={() => setCurrentPage(k + 1)}
            >
              {k + 1}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
          >
            <img style={{ transform: "rotateY(180deg)" }} src={arrowIcon} alt="arrow-icon" />
          </button>
        </div>
      </div>

    </div>
  );
};

export default ManageFaq;
